import styled from '@emotion/styled';
import Logo from 'presentations/views/components/atoms/Logo';

export default function Component() {
  return (
    <Header>
      <Logo width={130} />
    </Header>
  );
}

const Header = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 8px 20px;
`;
